import type { Option } from '@openx/types/options.ts';
import type { UseContextualDataPartnerOptions } from '@openx/types/targeting/targetingHookTypes.ts';
import { useEffect, useMemo } from 'react';
import { useInfiniteSearchOptionsByPathQuery } from '../../../hooks/useSearchOptionsByPathQuery.ts';

const DATA_PARTNERS_PAGE_SIZE = 100;

export const useContextualDataPartnerOptions: UseContextualDataPartnerOptions = () => {
  const { pages, hasNextPage, isFetching, fetchNextPage } = useInfiniteSearchOptionsByPathQuery({
    pageSize: DATA_PARTNERS_PAGE_SIZE,
    variables: {
      filter: { sellable_only: true },
      path: 'deal.package.targeting.contextual.providers',
    },
  });

  const dataPartnerOptions = useMemo<Option[]>(() => {
    const options = pages.flatMap(page =>
      page.searchOptionsByPath.results.map(option => ({ id: option.id, name: option.name }))
    );

    return Array.from(new Map(options.map(option => [option.id, option])).values());
  }, [pages]);

  useEffect(() => {
    if (hasNextPage && !isFetching) {
      fetchNextPage();
    }
  }, [fetchNextPage, hasNextPage, isFetching]);

  return { dataPartnerOptions, dataPartnerOptionsLoading: isFetching };
};
